import { ProjectAnalysesSectionPage } from '@/pages/ProjectAnalysesSectionPage';

export function ProjectAnalysesComparaisonsPage() {
  return <ProjectAnalysesSectionPage sectionTitle="Comparaisons" />;
}

